import type { PageContentEditorBlock } from '@app/components/blocks/pageContentEditor/PageContentEditor'
import { useClient } from '@based/sdk/react'
import { useToast } from '@app/util/hooks/useToast'
import { useEffect, useRef } from 'react'
import {
  contentBlocksFingerprint,
  persistInitiativePageContentBlocks,
} from './initiativeOverviewTextBlocks'

export const useInitiativePageContentBlocksSave = (
  initiativeId: number,
  serverBlocks: PageContentEditorBlock[],
  draftBlocks: PageContentEditorBlock[],
): void => {
  const client = useClient()
  const { showFailToast } = useToast()
  const serverPrint = contentBlocksFingerprint(serverBlocks)
  const draftPrint = contentBlocksFingerprint(draftBlocks)
  const serverRef = useRef(serverBlocks)
  const draftRef = useRef(draftBlocks)
  serverRef.current = serverBlocks
  draftRef.current = draftBlocks

  useEffect(() => {
    if (draftPrint === serverPrint) {
      return
    }
    const t = setTimeout(() => {
      void (async () => {
        try {
          await persistInitiativePageContentBlocks(
            (name, payload) => client.call(name, payload),
            initiativeId,
            serverRef.current,
            draftRef.current,
          )
        } catch {
          showFailToast()
        }
      })()
    }, 600)
    return () => clearTimeout(t)
  }, [draftPrint, serverPrint, initiativeId, client, showFailToast])
}
